export default function getSelectedFacets(facets) {
	const selectedFacets = []
	const hasFacets = facets && facets.length
	const hasOptions = facet => facet.options && facet.options.length

	const saveSelectedFacet = facet => {
		facet.options.forEach(option => {
			if (option.selected) selectedFacets.push({ facet: facet.name, ...option })
		})
	}

	if (hasFacets) {
		facets?.forEach(facet => {
			if (hasOptions(facet)) saveSelectedFacet(facet)
		})
	}

	return selectedFacets
}
